var _excluded = ["values", "digitTypography", "labelColor", "labelTypography", "digitColor", "digitBackground", "isSmall"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { Fragment, useContext } from "react";
import styled, { css } from "styled-components";
import OnColorContext from "../../../contexts/OnColorContext";
import breakpoint from "../../../utils/breakpoint";
import getBorderColor from "../../../utils/getBorderColor";
import getBorderRadius from "../../../utils/getBorderRadius";
import getColor from "../../../utils/getColor";
import space, { spaceFactor } from "../../../utils/space";
import unit from "../../../utils/unit";
import TextAtm from "../../atoms/TextAtm";
export var defaultProps = {
  digitTypography: "xlarge",
  labelTypography: "tiny1"
};
var digitVerticalPaddingSpaceOnSmallOnly = 0.5;
var digitVerticalPaddingSpaceOnMediumUp = 1;
var borderWidth = 1;
var digitSmallVerticalPaddingUnit = 2;
var digitSmallPaddingUnit = 3;
var Values = styled.div.withConfig({
  componentId: "sc-xfc7gl-0"
})(["display:inline-flex;"]);
var Value = styled.div.withConfig({
  componentId: "sc-xfc7gl-1"
})(["display:flex;flex-direction:column;align-items:center;"]);
var Digits = styled.div.withConfig({
  componentId: "sc-xfc7gl-2"
})(["display:grid;grid-template-columns:1fr 1fr;gap:", ";margin-bottom:", ";"], space(0.5), space(0.5));
var Digit = styled(TextAtm).withConfig({
  componentId: "sc-xfc7gl-3"
})(function (_ref) {
  var $background = _ref.$background,
    $onColor = _ref.$onColor,
    theme = _ref.theme,
    $isSmall = _ref.$isSmall;
  return css(["padding:", " ", ";border:", " solid ", ";border-radius:", ";background:", ";text-align:center;min-width:", ";&::before{content:\"4\";display:block;visibility:hidden;height:0;overflow:hidden;}", "{padding:", " ", ";}"], $isSmall ? unit(digitSmallPaddingUnit) : space(digitVerticalPaddingSpaceOnSmallOnly), $isSmall ? unit(digitSmallPaddingUnit) : space(0.5), unit(borderWidth), getBorderColor(theme, $onColor, "low"), getBorderRadius(theme, $isSmall ? "small" : "large"), $background && getColor(theme, $background), unit(24), breakpoint("medium"), $isSmall ? unit(digitSmallPaddingUnit) : space(digitVerticalPaddingSpaceOnMediumUp), $isSmall ? unit(digitSmallPaddingUnit) : space(1.5));
});
var Separator = styled(TextAtm).withConfig({
  componentId: "sc-xfc7gl-4"
})(function (_ref2) {
  var $isSmall = _ref2.$isSmall;
  return css(["margin:0 ", ";padding-top:", ";", "{margin:0 ", ";padding-top:", ";}"], $isSmall ? unit(digitSmallVerticalPaddingUnit) : space(1), unit(digitVerticalPaddingSpaceOnSmallOnly * spaceFactor + borderWidth), breakpoint("medium"), $isSmall ? unit(digitSmallVerticalPaddingUnit) : space(1.5), unit($isSmall ? 5 : digitVerticalPaddingSpaceOnMediumUp * spaceFactor + borderWidth));
});
function CountdownMol(_ref3) {
  var values = _ref3.values,
    _ref3$digitTypography = _ref3.digitTypography,
    digitTypography = _ref3$digitTypography === void 0 ? defaultProps.digitTypography : _ref3$digitTypography,
    labelColor = _ref3.labelColor,
    _ref3$labelTypography = _ref3.labelTypography,
    labelTypography = _ref3$labelTypography === void 0 ? defaultProps.labelTypography : _ref3$labelTypography,
    digitColor = _ref3.digitColor,
    digitBackground = _ref3.digitBackground,
    isSmall = _ref3.isSmall,
    restProps = _objectWithoutProperties(_ref3, _excluded);
  var onColor = useContext(OnColorContext);
  return /*#__PURE__*/React.createElement(Values, restProps, values.map(function (_ref4, index) {
    var value = _ref4.value,
      label = _ref4.label;
    var isLastElement = values.length === index + 1;
    var stringAsNumber = parseInt(value, 10);
    var digit = value;
    if (stringAsNumber < 10) {
      digit = "0".concat(value);
    }
    var typography = isSmall ? "xsmall3" : digitTypography;
    return /*#__PURE__*/React.createElement(Fragment, {
      key: label
    }, /*#__PURE__*/React.createElement(Value, null, /*#__PURE__*/React.createElement(Digits, null, /*#__PURE__*/React.createElement(Digit, {
      color: digitColor,
      typography: typography,
      $background: digitBackground,
      $onColor: onColor,
      $isSmall: isSmall
    }, digit[0]), /*#__PURE__*/React.createElement(Digit, {
      color: digitColor,
      typography: typography,
      $background: digitBackground,
      $onColor: onColor,
      $isSmall: isSmall
    }, digit[1])), !isSmall && /*#__PURE__*/React.createElement(TextAtm, {
      color: labelColor,
      typography: labelTypography
    }, label)), !isLastElement && /*#__PURE__*/React.createElement(Separator, {
      typography: typography,
      $isSmall: isSmall
    }, ":"));
  }));
}
export default CountdownMol;